import classNames from "classnames"
import { twMerge } from "tailwind-merge"

type ClassValue =
  | string
  | number
  | bigint
  | boolean
  | ClassValue[]
  | {
      [key: string]: any
    }
  | null
  | undefined

export function cn(...inputs: ClassValue[]) {
  return twMerge(classNames(inputs))
}
